const { ActionTypes } = require("../constants/action_types");

const initialState =1;

export const increaseCountReducer = (state = initialState, { type }) => {

    switch (type) {
        case ActionTypes.INCREASE_COUNT:
            return state = state+1; //sidebarShow 
        default:
            return state;
    }
};